import clsx, { ClassValue } from 'clsx'
import { useTranslation } from 'react-i18next'

export type FormattedNumberProps = {
  value: number
  compact?: boolean
  className?: ClassValue
}

export function FormattedNumber (props: FormattedNumberProps) {
  const { value, compact, className } = props
  const { i18n } = useTranslation()

  const formatter = new Intl.NumberFormat(
    compact ? 'en' : i18n.language, {
      notation: compact ? 'compact' : 'standard',
      compactDisplay: compact ? 'short' : undefined
    }
  )

  const formatted = formatter.format(value)

  return (
    <span className={clsx('whitespace-nowrap', className)}>
      {formatted}
    </span>
  )
}
